<template>
	<RouterLink :to="`/jobs/${job.uuid}/details`">
		<div class="box mb-5 px-3 py-5 is-flex" >
			<table>
				<tbody>
					<tr>
						<td>
							<div class="map px-2 is-flex">
								<img class="is-align-self-center is-justify-content-center map-image" src="@/assets/images/placeholders/small-map.png" />
							</div>
						</td>
						<td>
							<div class="is-size-6_5">
								<div v-if="job.date">Date: <span class="bold-text">{{ date }}</span></div>
								<div v-if="job.start_time">Arrival Window: <span class="bold-text">{{ time }}</span></div>
								<div v-if="job.device">Device: <span class="bold-text">{{ job.device }}</span></div>
								<div v-if="job.description">Description: <span class="bold-text">{{ job.description }}</span></div>
								<div v-if="job.zipcode">Zipcode: <span class="bold-text">{{ job.zipcode }}</span></div>
								<div class="badges">
									<span v-if="job.is_diagnostic" class="m-1 px-2 py-1 is-radius-3 is-size-7 medium-text" :style="{ background: colors[filters.DIAGNOSTIC].color}">
										Diagnostic
									</span>
									<span v-if="job.is_completed" class="m-1 px-2 py-1 is-radius-3 is-size-7 medium-text" :style="{ background: colors[filters.COMPLETED].color}">
										Complete
									</span>
									<span  v-if="job.is_followup" class="m-1 px-2 py-1 is-radius-3 is-size-7 medium-text" :style="{ background: colors[filters.FOLLOW_UP].color}">
										Follow-up
									</span>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>	
	</RouterLink>
</template>

<script lang="ts">
import { AvailableJob, JobsFilters, JobsFiltersOptions } from '@/models/JobsState';
import { DEFAULT_SLOT_DURATION } from '@/utils/formatters';
import { timeSlotsUtils } from '@puls/puls-general-utils';

import moment from 'moment';
import { defineComponent } from 'vue';

export default defineComponent({
	data () {
		return {
			colors: JobsFiltersOptions,
			filters: JobsFilters
		}
	},
	computed: {
		date () : string {
			const timeDate = moment(this.job.date).startOf('day');
			timeDate.add(this.job.start_time, "minutes");
			return `${timeDate.format('MMM, DD YYYY')}`
		},
		time () : string {
			if (this.job.start_time) { 	
				return timeSlotsUtils.formatTimeSlot(parseInt(this.job.start_time), DEFAULT_SLOT_DURATION);
			} 
			return 'N/A'
		}
	},
	props: {
		job: {
			type: Object as () => AvailableJob,
			required: true
		}
	}
})
</script>

<style scoped lang="scss">
	.box{
		position: relative;
	}
	.badges {
		position: absolute;
		left: 0;
		top: -18px;
		left: 12px;
		span {
			display: inline-block;
			border-bottom: 1px solid #ddd;	
		}
	}

	.map{
		width: 100px;
		img{
			vertical-align: middle;
		}
	}

	.map-image{
		width: 100%;
	}
</style>
